<div class="row" style="margin-top: 5px;margin-bottom: 0px;">
    <div class="two columns">
        <div class="label">
            {{'Type' | translate}}
        </div>
        <div class="field">
            <select
                soho-dropdown noSearch
                [attributes]="typeAutomationId"
                bindId="type"
                [(ngModel)]="computeRow.type"
                (change)="clearField()"
            >
                <option *ngFor="let item of types" [value]="item.value">{{item.label}}</option>
            </select>
        </div>
    </div>
    <div class="three columns">
        <ng-container *ngIf="computeRow.type === 'field'; else literal">
            <lm-filter-builder-field-lookup
                    id="computeField"
                    [index]="index"
                    [qualifier]="computeRow.field"
                    [businessClass]="businessClass"
                    [lookupUrl]="lookupUrl"
                    [fieldSearchUrl]="fieldSearchUrl"
                    [lplValidationUrl]="lplValidationUrl"
                    [includeAuditFields]="includeAuditFields"
                    attr.data-automation-id="lm-compute-builder-row-compute-field-{{index}}"
                    position="computeField"
                    mode="Fields"
                    (fieldSelectionEvent)="handleFieldLookUpEvent()"
            >
            </lm-filter-builder-field-lookup>
        </ng-container>
        <ng-template #literal>
            <div class="field">
                <label soho-label>{{'LiteralValue' | translate}}</label>
                <input
                        class="input-mm"
                        [attr.id]="literalId"
                        [attr.bindId]="computeRow.field"
                        type="text"
                        [(ngModel)]="computeRow.field.text"
                        (input)="handleFieldChange()"
                        [attr.data-automation-id]="literalAutomationId"
                />
            </div>
        </ng-template>
    </div>
    <div class="two columns">
        <div class="field">
            <label soho-label>{{'FunctionLabel' | translate}}</label>
            <select
                    soho-dropdown noSearch
                    bindId="function"
                    [(ngModel)]="computeRow.function"
                    [disabled]="computeRow.type !== 'field'"
                    (change)="handleFieldChange()"
                    [attributes]="functionAutomationId"
            >
                <option *ngFor="let item of functions" [value]="item.value">{{item.label}}</option>
            </select>
        </div>
    </div>
    <div class="one column">
        <div class="field">
            <label soho-label>{{ 'OperatorsLabel' | translate }}</label>
            <select
                soho-dropdown noSearch
                bindId="operator"
                [(ngModel)]="computeRow.operator"
                (change)="onOperatorChange()"
                [attributes]="operatorAutomationId"
            >
                <option *ngFor="let item of operators" [value]="item.value">{{item.label}}</option>
            </select>
        </div>
    </div>

    <div class="one column">
        <div class="field">
            <div class="label">
                &nbsp;
            </div>
            <button soho-button="icon"
                    (click)="onRemoveButtonEvent()"
                    icon="delete"
                    title="{{'Delete' | translate }}"
                    [attr.data-automation-id]="deleteAutomationId"
            ><span #LmButtonIcon class="lm-button-icon" role="presentation" aria-hidden="true"></span></button>
        </div>
    </div>
</div>

